import { RequestKind } from '@sb/library/base';
import { MembershipCurrencyDisplayItem, NameCodePair } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace CurrencyRoutes {
    export const Get = ApiRoute.Define({
        URL: (currencyCode: string) => `membershipcurrencies/${currencyCode}`,
        Kind: RequestKind.Get,
        ResultType: MembershipCurrencyDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: `membershipcurrencies`,
        Kind: RequestKind.Get,
        ResultType: Array<MembershipCurrencyDisplayItem>
    });

    export const GetOnlinePayment = ApiRoute.Define({
        URL: (onlinePaymentProcessor: string) => `onlinepaymentcurrencies/${onlinePaymentProcessor}`,
        Kind: RequestKind.Get,
        ResultType: Array<NameCodePair>
    });
}
